const BORDER = 'border';
const BORDER_LEFT = 'border-left';
const BORDER_TOP = 'border-top';
const BORDER_RIGHT = 'border-right';
const BORDER_BOTTOM = 'border-bottom';
const PADDING = 'padding';
const PADDING_LEFT = 'padding-left';
const PADDING_TOP = 'padding-top';
const PADDING_RIGHT = 'padding-right';
const PADDING_BOTTOM = 'padding-bottom';

export const backgroundColor = function(style) {

  if (! style.hasOwnProperty('backgroundColor')) {
    return {}
  }

  // Verify that background is not gradient
  if (style.backgroundColor.search(",") === -1) {
    return {
      backgroundColor: style.backgroundColor,
    };
  }

  return gradientImage(style.backgroundColor)
}

export const gradientImage  = function (backgroundColor) {

  let background = backgroundColor.match(/[a-f0-9]{6}/i)

  if (background === null) {
    background = backgroundColor
  }

  return {
    background: "#" + (background.length > 0  ? background[0] : backgroundColor),
    backgroundImage: 'linear-gradient(' + backgroundColor + ')'
  };
}

export const fontColor = function (style) {
  return {
    color: style.fontColor || 'none'
  }
}

export const padding = function(style) {

  return {
    'padding-left': style.paddingTop + 'px',
    'padding-top': style.paddingTop + 'px',
    'padding-right': style.paddingTop + 'px',
    'padding-bottom': style.paddingBottom + 'px'
  }
}

export const border = function (border) {

  if ( typeof border === "undefined") {
    return;
  }

  if (border.styleName === 'none') {
    return {
      border: 'none'
    }
  }

  const borderValues = [
    border.styleName,
    border.size + 'px',
    border.color
  ].join(" ");

  return {
    'border-left': border.left ? borderValues : 'none',
    'border-top': border.top ? borderValues : 'none',
    'border-right': border.right ? borderValues : 'none',
    'border-bottom': border.bottom ? borderValues : 'none',
  }
};

export const boxShadow = function(boxShadow) {

  if ( typeof boxShadow === "undefined") {
    return;
  }

  const boxShadowValues = [
    0,
    boxShadow.blurRadius + 'px',
    boxShadow.spreadRadius + 'px',
    boxShadow.color
  ].join(" ");

  if (!boxShadow.visible) {
    return {
      "box-shadow": 'none'
    };
  }

  return {
    '-webkit-box-shadow': boxShadowValues,
    '-moz-box-shadow': boxShadowValues,
    'box-shadow': boxShadowValues,
    //'-webkit-transform': 'rotate(-8deg)',
    //'-moz-transform': 'rotate(-8deg)',
    //'-o-transform': 'rotate(-8deg)',
    //'-ms-transform': 'rotate(-8deg)',
    //'transform': 'rotate(-8deg)',
  }
}

export default { backgroundColor, fontColor, padding, border, boxShadow, gradientImage };
